<template>
  <div aria-live="polite" aria-atomic="true" class="position-relative">
    <div class="toast-container position-fixed top-0 end-0 p-3">
      <div
        v-for="(toast, index) in localToasts"
        :key="toast.id"
        class="toast"
        :class="toast.class"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        :data-bs-delay="toast.delay"
        :data-bs-autohide="toast.autohide"
        ref="toasts"
      >
        <div class="toast-header">
          <strong class="me-auto">{{ toast.title }}</strong>
          <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close" @click="removeToast(index)"></button>
        </div>
        <div class="toast-body">
          {{ toast.message }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'bootstrap'
export default {
  name: 'ZToast',
  data() {
    return {
      localToasts: []
    }
  },
  mounted() {
    this.emitter.on('show-toast', (toast) => {
      this.addToast(toast)
    })
  },
  methods: {
    addToast(toast) {
      const id = Date.now() // Unique ID for each toast
      const newToast = {
        id,
        title: toast.title || 'Notification',
        message: toast.message || '',
        class: toast.class || 'bg-primary text-white',
        delay: toast.delay || 2000,
        autohide: toast.autohide !== undefined ? toast.autohide : true
      }
      this.localToasts.push(newToast)
      console.log('Toast Added', this.localToasts)
      this.$nextTick(() => {
        const toastElement = this.$refs.toasts[this.localToasts.length - 1]
        const toastInstance = new Toast(toastElement)
        toastInstance.show()

        // Remove toast after it's hidden
        toastElement.addEventListener('hidden.bs.toast', () => {
          this.localToasts = this.localToasts.filter((t) => t.id !== id)
        })
      })
    },
    removeToast(index) {
      this.localToasts.splice(index, 1)
    }
  },
  beforeUnmount() {
    this.emitter.off('show-toast')
  }
}
</script>

<style scoped>
.toast-container {
  z-index: 1055;
}
</style>
